module.exports = __webpack_public_path__ + "img/i-profil-black.a40763a0.svg";